import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import "./index.scss";
import useInputKeys from "hooks/useInputKeys";

function GameDescription({ handleNext, history }) {
  const { t } = useTranslation();
  const { direction } = useInputKeys();

  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();

      const tehranNow = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Tehran" })
      );

      const tehranMidnight = new Date(tehranNow);
      tehranMidnight.setHours(24, 0, 0, 0); 

      const diff = tehranMidnight - tehranNow;

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(
        `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
          2,
          "0"
        )}:${String(seconds).padStart(2, "0")}`
      );
    }, 0);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box className="guess-number-game-description-component">
      <Box className={`${direction} description`}>{t("guessNumberDescription")}</Box>
      {history?.hasWon ? (
        <Box className="lunch-button disabled-lunch">
          <button disabled>
            {t("nextCodeAvailable", { count: timeLeft })}
          </button>
        </Box>
      ) : (
        <Box className="lunch-button" onClick={() => handleNext()}>
          <button>{t("lunchGuessNumber")}</button>
        </Box>
      )}
    </Box>
  );
}

export default GameDescription;
